import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
    Box,
    Typography,
    Paper,
    IconButton,
    Tooltip
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import searchStore from '../../Mobx/SearchStore';

const SearchQueryViewer = observer(() => {
    const [copied, setCopied] = useState(false);
    const request = searchStore.builtQuery;
    const jsonString = JSON.stringify(request, null, 2);

    const handleCopy = () => {
        navigator.clipboard.writeText(jsonString);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Paper
            sx={{
                p: 1,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                minHeight: 0,
                position: 'relative',
            }}
        >
            {/* כותרת */}
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                אובייקט החיפוש
            </Typography>

            {/* כפתור העתקה עם Tooltip וצבע אפור מעודן */}
            <Tooltip title={copied ? 'ה־JSON הועתק ללוח!' : 'העתק JSON'}>
                <IconButton
                    onClick={handleCopy}
                    size="small"
                    sx={{
                        position: 'absolute',
                        top: 6,
                        right: 15,
                        backgroundColor: copied ? '#f5f5f5' : 'white',
                        color: copied ? '#555' : '#333',
                        transform: copied ? 'scale(1.05)' : 'scale(1)',
                        transition: 'all 0.3s ease',
                        zIndex: 2,
                        '&:hover': {
                            backgroundColor: copied ? '#e0e0e0' : '#f0f0f0',
                        },
                    }}
                >
                    {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                </IconButton>
            </Tooltip>

            {/* תיבת הקוד */}
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'auto',
                    direction: 'ltr',
                    mt: 1,
                }}
            >
                <SyntaxHighlighter
                    language="json"
                    style={vscDarkPlus}
                    wrapLongLines
                    customStyle={{ margin: 0 }}
                >
                    {jsonString}
                </SyntaxHighlighter>
            </Box>
        </Paper>
    );
});

export default SearchQueryViewer;
